import React from 'react'
import {findDOMNode} from "react-dom"

import Popover from '../../../../../../core/gd-components/gd-popover/popover-v2'
import PopoverPosition from '../../../../../../core/gd-components/gd-popover/popover-position'
import {PopoverAttachmentType} from '../../../../../../core/gd-components/gd-popover/@const'
import PopupMenuButton from "../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import MoreMenu from "../submenu-item/more-popover/more-menu"
import ProjectView from "../../../../../../core/model2/project-view/project-view"

type Props = {
    projectId           : ID
    defaultInfo         : string

    additionalViews     : ProjectView[]

    onTogglePopover?    : func
}

export default class ProjectMenuMore extends React.Component<Props, any> {

    private morePopoverIsShown: boolean = false

    static defaultProps = {
        defaultInfo     : 'Select view',
        additionalViews : []
    }

    constructor(props: Props) {
        super(props)

        this.state = _.assign(this.state, {
            showPopover: false
        })
    }

    showPopover = (e?: React.MouseEvent, callback?: callback) => {
        if (e) e.stopPropagation()

        this.setState({
            showPopover: true
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(true)
            if (callback) callback()
        })
    }

    hidePopover = (e?: React.MouseEvent, callback?: callback) => {
        if (this.morePopoverIsShown) return

        if (e) e.stopPropagation()
        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false)
            if (callback) callback()
        })
    }

    onMorePopoverToggle = (value: boolean) => {this.morePopoverIsShown = value} //to prevent hide popover on click outside while more is open

    onClickView = (view: ProjectView) => {
        this.hidePopover()
        view.open()
    }

    /*renderItem = (key: any, view: ProjectView) => {
        return (
            <div key={key} className="option with-more" onClick={this.onClickView.bind(this,view)}>
                <div className="label">{view.name}</div>

                {view.access==='private' && <div className="ui5-ico-12 i5-lock"></div>}

                {view.hasMoreMenu &&
                    <PopupMenuButton className="ui5-ico-more s20 gd-ui-more-button-container"
                                     popoverClass="popover-project-view"
                                     attachment="top left"
                                     targetAttachment="top right"
                                     offset="12px -4px"
                                     menuComponent={MoreMenu}
                                     menuParams={{
                                         view: view
                                     }}
                                     onTogglePopover={this.onMorePopoverToggle}/>}

            </div>
        )
    }*/

    renderPopover() {
        if (this.state.showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment      : "top center",
                targetAttachment: "bottom center",
                attachmentType  : PopoverAttachmentType.HORIZONTAL,
            })

            return (
                <Popover position           = {popoverPosition}
                         onClickOutside     = {()=>{this.hidePopover()}}
                         getTargetFunc      = {() => findDOMNode(this)}>
                    <div className="ui5-popover-menu">
                        {_.map(this.props.additionalViews, (view, key) => {
                            return (
                                <div key={key} className="option with-more" onClick={this.onClickView.bind(this, view)}>
                                    <div className="label">{view.name}</div>

                                    {view.access === 'private' && <div className="ui5-ico-lock s8 h-20 m-l-3"/>}

                                    {view.hasMoreMenu &&
                                        <PopupMenuButton className="ui5-ico-more s20 gd-ui-more-button-container"
                                                         popoverClass="popover-project-view"
                                                         attachment="top left"
                                                         targetAttachment="top right"
                                                         offset="12px -4px"
                                                         menuComponent={MoreMenu}
                                                         menuParams={{
                                                             view: view
                                                         }}
                                                         onTogglePopover={this.onMorePopoverToggle}/>}

                                </div>
                            )
                        })}
                    </div>
                </Popover>
            )
        }
    }

    render() {
        return (
            <div className="item with-counter" onClick={this.showPopover}>
                <div className="label">More</div>
                <div className="counter">{this.props.additionalViews.length}</div>

                <div className="ui5-triangle-toggle s7 open"/>
                {this.renderPopover()}
            </div>
        )
    }
}
